import React from "react";
import SimpleFooter from "@/components/interviews/Footer/SimpleFooter";
import styles from "./ErrorPage.module.css";
import { IErrorPageProps } from "./ErrorPage.types";

function ErrorPage({ title, description }: IErrorPageProps): React.JSX.Element {
  return (
    <div className="d-flex flex-column align-content-center flex-wrap">
      <h1
        className={`${styles.title} d-flex justify-content-center text-center"`}
      >
        {title}
      </h1>
      <div className={styles.errorDescriptionCard}>{description}</div>

      <SimpleFooter />
    </div>
  );
}

export default ErrorPage;
